import report from "../../api/report";
import { perPageCount } from "@/common/constants";
import {
  percentageVieW,
  dummyRows,
  StatusIcon,
  convertCount,
} from "@/common/functions";

const getDefaultState = () => {
  return {
    items: [],
    loaded: false,
    filter: {
      page: 1,
      per_page_count: perPageCount,
      camp_name: "",
      search_date_from: "",
      search_date_to: "",
      search_sender_id: "",
      search_status: "",
      _route: "campaign_report",
      exportData: 0,
      sort_field: "scheduleDate",
      sort_order: "desc",
      add_sort: 0,
    },
    totalItems: 0,
    exportError: "",
    total: 0,
    busyLoaderStatus: true,
    showFilter: false,
    campaignName: "",
    domainWiseReport: [],
    domainWiseCount: 0,
    domainWiseLoaded: false,
    domainWiseBusyLoader: true,
    allCounts: [],
    domainAbLoader: false,
    advancedCampaignOptions: 0,
    allowInbox: 0,
  };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
  getItems: (state) => {
    if (!state.items.length && !state.loaded) {
      return dummyRows();
    }
    return state.items.map((item) => {
      var icon = StatusIcon(item.statusname);
      var type = "";
      if (item.type !== 1) {
        type = "A/B";
      }
      var sentPer =
        percentageVieW(
          item.sentto,
          item.type === 4 ? item.maxLimit : item.queuedTotal
        ) + "%";
      var clickPer = percentageVieW(item.clicks, item.opens) + "%";
      // var openPer = percentageVieW(item.opens, item.sentto) + '%'
      var unsubs = percentageVieW(item.unsubs, item.opens) + "%";
      var getPauseMessage = (item) => {
        var pauseMessage = item.pauseMessage ? item.pauseMessage : "";
        var base = "BOUNCE RATE EXCEEDED, CURRENT BOUNCE RATE";
        var pseMsg = "CAMPAIGN IS ABORTED, SINCE BOUNCE RATE EXCEEDED";
        var pausemsg = [
          "Your subscription is unpaid. Campaign paused.",
          "Your subscription is canceled. Campaign paused.",
          "Your subscription is expired. Campaign paused.",
          "Client quota exceeded. Campaign paused.",
          "Campaign paused due to broken links and blacklist domains",
          "Campaign paused due to broken links",
          "Campaign paused due to blacklist domains",
        ];
        if (
          (parseInt(item.status) === 5 &&
            ((item.pauseCampaign && pauseMessage) ||
              (pauseMessage && pausemsg.includes(pauseMessage)))) ||
          (item.status === 7 &&
            pauseMessage &&
            (pauseMessage.toLowerCase().includes(base.toLowerCase()) ||
              pauseMessage.toLowerCase().includes(pseMsg.toLowerCase())))
        ) {
          return pauseMessage;
        } else {
          return "";
        }
      };
      return {
        id: item.id,
        campName: {
          title: item.campName,
          type,
          text: item.scheduleDate,
          subjectline: item.campSubject,
        },
        cam_status: {
          text: item.statusname,
          type: icon,
          time: item.statusChangeDate,
        },
        sentto: { first: convertCount(item.sentto), second: sentPer },
        openRate: {
          first: item.openRate + "%",
          second: convertCount(item.opens),
        },
        clicks: { first: convertCount(item.clicks), second: clickPer },
        unsubs: { first: convertCount(item.unsubs), second: unsubs },
        pause_message: getPauseMessage(item),
        isTimeBased: item.isTimeBased,
        isAmp: [3, 4].includes(item.contenttype),
        showCampaign: item.showCampaign,
        isAdvanced: parseInt(item.isAdvanced),
        inbox: item.inbox || [],
        isNormal: item.connectId === 0,
      };
    });
  },
  getDomainWiseItems: (state) => {
    if (!state.domainWiseReport.length && !state.domainWiseLoaded) {
      return dummyRows();
    }
    const allCounts = state.allCounts;
    return state.domainWiseReport.map((item) => {
      return {
        domain: item.domain,
        sent: convertCount(item.sent),
        soft_bounce: convertCount(item.soft_bounce),
        hard_bounce: convertCount(item.hard_bounce),
        opens: convertCount(item.opens),
        clicks: convertCount(item.clicks),
        replay: 0,
        unsubscribe: convertCount(item.unsubscribe),
        abuse: convertCount(item.abuse),
        spam_complaints: convertCount(item.spam_complaints),
        dom_type: item.dom_type,
        sent_percent: percentageVieW(item.sent, allCounts.sent) + "%",
        soft_bounce_percent: percentageVieW(item.soft_bounce, item.sent) + "%",
        hard_bounce_percent: percentageVieW(item.hard_bounce, item.sent) + "%",
        open_percent: percentageVieW(item.opens, item.sent) + "%",
        clicks_percent: percentageVieW(item.clicks, item.opens) + "%",
        unsub_percent: percentageVieW(item.unsubscribe, item.opens) + "%",
        abuse_percent: percentageVieW(item.abuse, item.opens) + "%",
        spam_comp_percent:
          percentageVieW(item.spam_complaints, item.sent) + "%",
      };
    });
    // }
  },
};

// actions
const actions = {
  fetchItems({ commit, state }, params) {
    var filter = state.filter;
    if (
      !state.loaded ||
      filter.page !== params.page ||
      filter.per_page_count !== params.per_page_count ||
      filter.camp_name !== params.camp_name ||
      filter.search_date_from !== params.search_date_from ||
      filter.search_date_to !== params.search_date_to ||
      filter.search_sender_id !== params.search_sender_id ||
      filter.search_status !== params.search_status ||
      filter.sort_field !== params.sort_field ||
      filter.sort_order !== params.sort_order
    ) {
      commit("setFilter", { ...params });
      return new Promise(function (resolve) {
        report.fetchItems(params, (data) => {
          commit("setAdvancedCampaignOptions", data.advancedCampaignOptions);
          commit("setAllowInbox", parseInt(data.allowInbox));
          commit("setItems", { items: data.items });
          commit("setTotalItems", data.total);
          commit("setLoaded", true);
          commit("setBusyLoaderStatus", true);
          resolve(data.total);
        });
      });
    }
  },
  exportItems(_, params) {
    var name = params._route + ".csv";
    return report.exportItems(params, { name });
  },
  refreshItems({ commit, state, dispatch }) {
    commit("setLoaded", false);
    dispatch("fetchItems", state.filter);
  },
  resetState({ commit }) {
    commit("resetState");
  },
  fetchDoaminWiseReport({ commit }, params) {
    return new Promise(function (resolve) {
      report.fetchDoaminWiseReport(params, (data) => {
        commit("setAllCounts", data.counts);
        commit("setDomainWiseReport", data.details);
        commit("setDomainWiseCount", data.totalCount);
        commit("setDomainWiseLoaded", true);
        commit("setDomainWiseBusyLoader", true);
        commit("setDomainAbLoader", false);
        resolve(data.totalCount);
      });
    });
  },
};

// mutations
const mutations = {
  setAllowInbox(state, data) {
    state.allowInbox = data;
  },
  setAdvancedCampaignOptions(state, data) {
    state.advancedCampaignOptions = data;
  },
  setItems(state, { items }) {
    state.items = items;
  },

  setFilter(state, data) {
    state.filter = data;
  },

  setTotalItems(state, total) {
    state.totalItems = total;
  },

  setLoaded(state, loaded) {
    state.loaded = loaded;
  },
  setExportError(state, data) {
    state.exportError = data;
  },
  setTotal(state, total) {
    state.total = total;
  },
  setBusyLoaderStatus(state, status) {
    state.busyLoaderStatus = status;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  setShowFilter(state, status) {
    state.showFilter = status;
  },
  setCampaignName(state, data) {
    state.campaignName = data;
  },
  setDomainWiseReport(state, data) {
    state.domainWiseReport = data;
  },
  setDomainWiseLoaded(state, status) {
    state.domainWiseLoaded = status;
  },
  setDomainWiseBusyLoader(state, status) {
    state.domainWiseBusyLoader = status;
  },
  setDomainWiseCount(state, data) {
    state.domainWiseCount = data;
  },
  setAllCounts(state, data) {
    state.allCounts = data;
  },
  setDomainAbLoader(state, flag) {
    state.domainAbLoader = flag;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
